import React/* , { useEffect, useState } */ from 'react';
import 'remixicon/fonts/remixicon.css';
import { ReactLenis } from 'lenis/react';
import { useSpring } from 'framer-motion';
import { Footer, Navbar, ModalProvider } from '../imports';
import useCursor from '../../animations/Cursor';
// import useMegaMenu from '../../hooks/useMegaMenu'

const Appwrapper = ({ children }) => {

  const spring = {
    type: 'spring',
    stiffness: 100,
    damping: 10,
    mass: 0.05,
  };

  const { mouseR, CursorLayout: Cursor } = useCursor();

  const mousePosition = {
    x: useSpring(-mouseR * 2, spring),
    y: useSpring(-mouseR * 2, spring)
  };

  const mouseMove = e => {
    const { clientX, clientY } = e
    const targetX = clientX - mouseR / 2
    const targetY = clientY - mouseR / 2
    mousePosition.x.set(targetX)
    mousePosition.y.set(targetY)
  };

  // const { expand } = useMegaMenu();
  // const [isLoaded, setIsLoaded] = useState(false);

  /*   useLayoutEffect(() => {
      setIsLoaded(true)
    }, []) */



  // TO TOP
/*   const [showButton, setShowButton] = useState(false);
  const [gradient, setGradient] = useState('radial-gradient(circle, #ff7e5f, #feb47b)');

  const handleScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollPosition = window.scrollY  // + window.innerHeight;
    const scrollPercent = (scrollPosition / scrollHeight) * 100;

    // Show button if scroll position exceeds 100% of the page height
    setShowButton(scrollPosition > window.innerHeight);
    // console.log(scrollPosition, window.innerHeight )

    // Update gradient based on scroll percentage
    const hue = (scrollPercent / 100) * 360; // Calculate hue based on scroll percentage
    const newGradient = `radial-gradient(${hue}deg, #ff7e5f, #feb47b)`; // Gradient with dynamic color
    setGradient(newGradient);
  };

  useEffect(() => {
    console.log()
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); */


  // TOP TOP 2
  // const { scrollY } = useScroll({ layoutEffect: false });

  // & TODO : IMPLEMENT TO TOP WITH ZUSTAND
  // TOP ZUSTAND
  // const { isActive, onClick, limit } = useTopScroll();


  // const handleScrollTop = () => { document.getElementById("main")?.scrollIntoView({ behavior: "smooth", }) };
  /*   useMotionValueEvent(scrollYProgress, "change", ((latest) => {
      setProgress(parseFloat(latest.toFixed(3)));
    })); */

  // const [progress, setProgress] = useState(Number(0));
  // const scrollPX = scrollY.get();

  /*   useEffect(() => {
      if (scrollPX > 1400) {
        setCanScroll(true)
      } else {
        setCanScroll(false)
      }
    }, [scrollPX]); */

  return (
    // isLoaded &&

    <ReactLenis root >

      {/* <LoadingScreen /> */}

      {/* <GridDisplay /> */}
      <main onMouseMove={mouseMove} className='relative w-full max-w-screen min-h-screen antialiased overflow-x-clip scrollbar-hide'>

        <Cursor mousePosition={mousePosition} />
        {/* <ToTop showButton={showButton} gradient={gradient} /> */}
        {/* <ScrollButton progress={progress} canScroll={canScroll} /> */}

        <ModalProvider />

        <Navbar />
        <div>
          {children}
          <Footer />
        </div>

      </main>
    </ReactLenis>

  )
}

export default Appwrapper
